var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIconForCourseContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.509,
    height: 43.509,
    viewBox: "0 0 43.509 43.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284",
    transform: "translate(-560.029 -423.029)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2863",
    "data-name": "Ellipse 2863",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(597 460) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_34_",
    "data-name": "svgexport-6 (34)",
    transform: "translate(603.538 466.538) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M0,6.009a1.2,1.2,0,0,0,1.2,1.2H4.807v3.605a1.2,1.2,0,1,0,2.4,0V7.211h3.605a1.2,1.2,0,1,0,0-2.4H7.211V1.2a1.2,1.2,0,1,0-2.4,0V4.807H1.2A1.2,1.2,0,0,0,0,6.009Z",
    transform: "translate(15.745 15.745)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M1.662,2.956l1.554-.644A1.2,1.2,0,1,0,2.3.092L.742.736a1.2,1.2,0,1,0,.92,2.221Z",
    transform: "translate(6.176 16.649) rotate(-45)",
    fill: "#dbdfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M15.383,0a1.2,1.2,0,0,0,0,2.4A12.979,12.979,0,1,1,2.4,15.383a1.2,1.2,0,0,0-2.4,0A15.383,15.383,0,1,0,15.383,0Z",
    transform: "translate(0 21.754) rotate(-45)",
    fill: "#dbdfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M2.052,3.241l1.19-1.19a1.2,1.2,0,0,0-1.7-1.7L.352,1.542a1.2,1.2,0,0,0,1.7,1.7Z",
    transform: "translate(5.032 21.754) rotate(-45)",
    fill: "#dbdfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10607",
    "data-name": "Path 10607",
    d: "M.742,3.867a1.2,1.2,0,0,0,1.57-.65l.644-1.554A1.2,1.2,0,0,0,.736.742L.092,2.3A1.2,1.2,0,0,0,.742,3.867Z",
    transform: "translate(6.175 26.859) rotate(-45)",
    fill: "#dbdfea"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconForCourseContent);
export default __webpack_public_path__ + "static/media/add-icon-for-course-content.9c515936a229f322879e24d97316008d.svg";
export { ForwardRef as ReactComponent };